// The view-consistency hold as the maker's screens read it. Everything here is empty while the backend switch
// (VIEW_CHECK_HOLD) is off, so the screens look exactly as before until it is turned on.
export { usd } from "./money";

export const VIEW_NAMES = { front: "front", back: "back", left: "left side", right: "right side", closeup: "face close-up" };

// {view: {code, reason}} still holding the duck: the broken views minus the ones owner/staff let through.
export const openBlocks = (vc) => {
  if (!vc?.hold) return {};
  const ok = new Set(vc.overridden || []);
  return Object.fromEntries(Object.entries(vc.broken || {}).filter(([v]) => !ok.has(v)));
};

export const isWaiting = (c) => !!c?.view_check?.hold && !!c.view_check.review;

// An "I have a render" upload held at the preview step because its front is not usable for the sculpt.
export const uploadHeld = (c) => c?.source === "render" && c?.status === "preview" && !!openBlocks(c?.view_check).front;

// Advisory colour flags for one view (never block); empty while the switch is off.
export const viewFlags = (vc, view) => (vc?.hold ? (vc.flags || []).filter((f) => f.view === view) : []);

export const fixNote = (flags) => flags.map((f) => f.note).filter(Boolean).join(" ");

export const holdCost = (vc, key) => (vc?.costs || {})[key];
